
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireced6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireced6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("fGjqO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("JSq6p").then(()=>parcelRequire("50i7i"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


var $f1f9b7c3604aa354$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["aT88m","index.c33d5f49.js","JSq6p","webfontloader.56fcc279.js"]'));

class $0ccbd4977765986b$export$60332b2344f7fe41 {
    constructor(game, config, onSwipe, cardIndex){
        this.dragStart = null;
        this.rotation = 0;
        this.maxRotation = 10;
        this.swiping = false;
        this.game = game;
        this.config = config;
        this.cardIndex = cardIndex;
        this.createCardElement();
        this.onSwipe = onSwipe;
    }
    release() {
        if (this.swiping) return;
        this.card.classList.remove("cursor-grabbing");
        this.card.classList.add("hover:cursor-grab");
        this.dragStart = null;
        if (Math.abs(this.rotation) > this.maxRotation / 2) {
            this.swipe();
            return;
        }
        this.card.style.transform = "";
        this.indicator.style.opacity = "0%";
    }
    swipe() {
        this.swiping = true;
        const direction = this.rotation > 0 ? "like" : "dislike";
        // this.game.cardContainer.removeChild(this.card);
        this.card.style.zIndex = "10";
        if (direction === "like") this.card.classList.add("animate-totheleft");
        if (direction === "dislike") this.card.classList.add("animate-totheright");
        if (this.config.points) {
            const points = this.config.points[direction];
            this.game.addPoints(points);
        }
        let rightAnswer = undefined;
        if (this.config.answer) {
            if (direction === this.config.answer) {
                this.game.addPoints(1);
                rightAnswer = true;
            } else {
                this.game.loseLife();
                rightAnswer = false;
            }
        }
        this.game.playerData.swipes.push({
            card: this.toString(),
            swipe: direction,
            rightAnswer: rightAnswer
        });
        this.onSwipe();
    }
    destroy() {
        this.card.remove();
    }
    toString() {
        let string = "";
        if (this.config.question) string += this.config.question + " - ";
        string += this.config.title;
        return string;
    }
    createCardElement() {
        this.card = document.createElement("div");
        this.card.className = "flex flex-col w-full h-full overflow-hidden absolute hover:cursor-grab touch-none";
        this.card.style.border = `${this.game.config.cardBorderWidth}px solid ${this.game.config.cardBorderColor}`;
        this.card.style.backgroundColor = `${this.game.config.cardColor}`;
        this.card.style.borderRadius = `${this.game.config.cardBorderRadius}px`;
        this.card.style.fontFamily = this.game.config.cardTitleFont || "inherit";
        this.card.style.fontSize = this.game.config.cardTitleSize + "px";
        this.card.style.color = this.game.config.cardTitleColor;
        this.card.onanimationend = ()=>{
            this.destroy();
        };
        if (this.cardIndex === 0) this.card.style.zIndex = "5";
        else this.card.style.zIndex = "2";
        let img = document.createElement("div");
        img.className = "h-full w-full bg-center bg-cover bg-no-repeat relative";
        img.style.padding = this.game.config.indicatorPadding + "px";
        img.style.backgroundImage = `url(${this.config.image})`;
        img.style.backgroundColor = "black";
        this.indicator = document.createElement("div");
        this.indicator.className = "aspect-square rounded-full flex items-center justify-center absolute text-black";
        this.indicator.style.width = this.game.config.indicatorWidth + "px";
        this.indicatorText = document.createElement("div");
        this.indicatorText.style.fontSize = `${this.game.config.indicatorWidth / 4}px`;
        this.indicator.appendChild(this.indicatorText);
        img.appendChild(this.indicator);
        this.indicatorImage = document.createElement("img");
        this.indicatorImage.className = "absolute";
        this.indicatorImage.style.width = this.game.config.indicatorWidth + "px";
        this.indicator.appendChild(this.indicatorImage);
        this.card.appendChild(img);
        if (this.game.config.showCardTitle) {
            let title = document.createElement("div");
            title.className = "text-center py-2";
            title.style.paddingRight = `${this.game.config.cardBorderRadius}px`;
            title.style.paddingLeft = `${this.game.config.cardBorderRadius}px`;
            title.innerHTML = this.config.title.replaceAll("_", " ");
            this.card.appendChild(title);
        }
        this.game.cardContainer.appendChild(this.card);
    }
    setIndicatorStyle() {
        const direction = this.rotation > 0 ? "right" : "left";
        this.indicator.style.opacity = Math.pow(Math.abs(this.rotation) / this.maxRotation, 2) * 100 + "%";
        let img;
        if (direction === "left") {
            this.indicator.style.left = "unset";
            this.indicator.style.right = this.game.config.indicatorPadding + "px";
            img = this.game.config.swipeLeftIndicatorImage;
        } else {
            this.indicator.style.right = "unset";
            this.indicator.style.left = this.game.config.indicatorPadding + "px";
            img = this.game.config.swipeRightIndicatorImage;
        }
        if (img === "false") {
            this.indicatorImage.hidden = true;
            return;
        }
        if (img) {
            this.indicator.style.backgroundColor = "transparent";
            this.indicatorImage.hidden = false;
            this.indicatorImage.src = img;
            this.indicatorImage.style.top = "0";
            this.indicatorText.innerHTML = "";
            if (direction === "left") {
                this.indicatorImage.style.right = "0";
                this.indicatorImage.style.left = "unset";
                return;
            }
            this.indicatorImage.style.left = "0";
            this.indicatorImage.style.right = "unset";
            return;
        }
        this.indicatorImage.hidden = true;
        this.indicator.style.backgroundColor = direction === "left" ? "red" : "green";
        this.indicatorText.innerHTML = direction === "left" ? "NEE" : "JA";
    }
}


// Message to the platform

class $22f5f922ddc3e706$export$2dffd0b5373a4389 {
    constructor(){
        this.game = undefined;
        window.addEventListener("message", (ev)=>{
            this.receive(ev.data);
        });
        window.pew = this;
    }
    receive(data) {
        if (!this.game) {
            console.error("Error: Game not set");
            return;
        }
        switch(data.eventName){
            case "play":
                this.game.play(); // Send play message to the game
                break;
            case "restart":
                this.game.restart();
        }
    }
    init(game, config) {
        this.game = game;
        // Load fonts and then send ready event
        let fonts = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = "" + v;
            if (key.toLowerCase().includes("font") && !key.toLowerCase().includes("color") && !key.toLowerCase().includes("size") && !fonts.includes(value) && !$22f5f922ddc3e706$var$excludedFonts.includes(value)) fonts.push(value);
        }
        if (fonts.length > 0) (parcelRequire("fGjqO")).then((webfont)=>{
            webfont.load({
                google: {
                    families: fonts
                },
                active: ()=>{
                // this.ready();
                }
            });
        });
    // } else {
    //   this.ready();
    // }
    }
    /**
   * Retrieve play event when game actualy starts
   */ gamestarted() {
        this.sendEvent({
            eventName: "start"
        });
    }
    play() {
        this.game?.play();
    }
    /**
   * Retrieve gameover event from game whith endsoce
   */ gameover(score, uitslag, custom) {
        this.sendEvent({
            eventName: "gameover",
            data: {
                score: score,
                outcome: uitslag,
                custom: custom
            }
        });
    }
    /**
   * Receive ready event from game when allowed to use start
   */ ready() {
        this.sendEvent({
            eventName: "ready"
        });
    }
    playSound(sound) {
        if (sound) this.sendEvent({
            eventName: "sound",
            data: this.game.config.path + "/" + sound
        });
    }
    preloadSounds(config) {
        let files = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = config.path + "/" + v;
            if (!files.includes(value) && key.includes("Sound")) files.push(value);
        }
        this.sendEvent({
            eventName: "preload-sounds",
            data: files
        });
    }
    /**
   * Send message to the game platform
   * @param event
   */ sendEvent(event) {
        window?.parent?.postMessage(event, "*");
    }
    sendScore(score) {
        this.sendEvent({
            eventName: "score",
            data: {
                score: score
            }
        });
    }
    sendProgress(progress) {
        this.sendEvent({
            eventName: "progress",
            data: progress
        });
    }
    sendTimeleft(time) {
        this.sendEvent({
            eventName: "timeleft",
            data: time
        });
    }
    sendLives(lives) {
        this.sendEvent({
            eventName: "lives",
            data: lives
        });
    }
}
const $22f5f922ddc3e706$var$excludedFonts = [
    "Arial",
    "Helvetica",
    "Comic Sans MS",
    "Courier New",
    "Courier",
    "Georgia",
    "Lucida Sans Unicode",
    "Lucida Grande",
    "Geneva",
    "Times New Roman",
    "Trebuchet",
    "Verdana"
];


class $37465c1b8ae3a0af$export$129163f547cade8e {
    constructor(){
        this.swipes = [];
        this.score = 0;
        this.uitslag = "";
    }
}


class $25326d3c4d4e80b0$export$8fdcabde73f49165 {
    constructor(game, score, configs){
        this.game = game;
        if (configs.length === 0) return;
        if (configs.length > 0) this.config = configs[0];
        if (this.game.config.randomResult) {
            const random = Math.round(Math.random() * (configs.length - 1));
            this.config = configs[random];
        } else for(let i = 0; i < configs.length; i++){
            const u = configs[i];
            if (score >= u.min && score <= u.max) this.config = u;
        }
        if (!this.config) return;
    // this.createCardElement();
    }
    toString() {
        let string = "";
        if (this.config.title) string += this.config.title;
        if (this.config.text) {
            if (string !== "") string += " - ";
            string += this.config.text;
        }
        return string;
    }
}


function $a0f1153633232d54$export$448332262467e042(array) {
    let currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle.
    while(currentIndex > 0){
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
}
function $a0f1153633232d54$export$ab82360ed81b09b9(s) {
    return /\d/.test(s);
}


class $7b066675d1aa79fa$export$38561bd03c7f0220 {
    constructor(config){
        this.firstGame = true;
        this.playing = false;
        this.playerData = new (0, $37465c1b8ae3a0af$export$129163f547cade8e)();
        this.cards = [];
        this.currentCard = 0;
        this.questionHeight = 0;
        this.platform = new (0, $22f5f922ddc3e706$export$2dffd0b5373a4389)();
        this.config = config;
        this.init();
    }
    getElement(name) {
        return document.getElementById(name);
    }
    init() {
        document.body.style.fontSize = this.config.fontSize + "px";
        document.body.style.color = this.config.fontColor;
        document.body.style.fontFamily = this.config.font;
        this.gameScreen = this.getElement("game-screen");
        this.cardContainer = this.getElement("card-container");
        this.cardContainer.style.backgroundColor = this.config.cardContainerColor;
        this.cardContainer.style.borderRadius = this.config.cardBorderRadius + "px";
        this.questionElement = this.getElement("question");
        this.questionElement.style.color = this.config.questionColor;
        this.questionElement.style.fontFamily = this.config.questionFont;
        this.questionElement.style.fontSize = this.config.questionSize + "px";
        if (!this.config.showQuestion) this.questionElement.remove();
        this.restart();
        this.platform.init(this, this.config);
        this.platform.preloadSounds(this.config);
    }
    nextQuestion() {
        const card = this.cards[this.currentCard];
        card.card.style.zIndex = "5";
        card.card.onpointerdown = (e)=>{
            if (!this.playing) return;
            card.dragStart = e.pageX;
            card.card.classList.remove("hover:cursor-grab");
            card.card.classList.add("cursor-grabbing");
        };
        card.card.onpointerup = (e)=>{
            if (!this.playing) return;
            if (card.dragStart) card.release();
        };
        document.body.onpointerleave = (e)=>{
            if (!this.playing) return;
            if (card.dragStart) {
                card.rotation = card.rotation > 0 ? card.maxRotation / 2 + 1 : -card.maxRotation / 2 - 1;
                card.release();
            }
        };
        card.card.onpointermove = (e)=>{
            e.preventDefault();
            if (!this.playing) return;
            if (!card.dragStart) return;
            const dragDelta = e.pageX - card.dragStart;
            card.rotation = Math.round(dragDelta / 10);
            if (card.rotation > 0 && card.rotation > card.maxRotation) card.rotation = card.maxRotation;
            else if (card.rotation < 0 && card.rotation < -card.maxRotation) card.rotation = -card.maxRotation;
            card.card.style.transform = `translateX(${dragDelta}px) rotate(${card.rotation}deg)`;
            card.setIndicatorStyle();
        };
        if (this.currentCard > 0 && this.currentCard + 1 < (this.config.cardLimit && this.config.cardLimit !== 0 ? Math.min(this.config.cardLimit, this.config.cards.length) : this.config.cards.length)) this.cards.push(new (0, $0ccbd4977765986b$export$60332b2344f7fe41)(this, this.config.cards[this.currentCard + 1], ()=>this.onSwipe(), this.currentCard + 1));
        if (!this.config.showQuestion) return;
        this.setQuestionElement(card.config);
    }
    onSwipe() {
        this.platform.playSound(this.config.swipeSound);
        this.currentCard += 1;
        this.setProgressBarWidth();
        if (this.currentCard >= (this.config.cardLimit && this.config.cardLimit !== 0 ? Math.min(this.config.cardLimit, this.config.cards.length) : this.config.cards.length)) this.goToResult();
        else this.nextQuestion();
    }
    play() {
        if (this.playing) return;
        this.playing = true;
        if (this.timeLeft) this.timeBarInterval = setInterval(()=>{
            this.timePassed(50);
        }, 50);
        this.platform.gamestarted();
    }
    loseLife() {
    // this.platform.playSound(this.config.wrongAnswerSound);
    // if (!this.lives) return;
    // this.lives -= 1;
    // this.platform.sendLives(this.lives);
    // if (this.lives === 0) {
    //   this.goToResult();
    // }
    }
    goToResult() {
        this.firstGame = false;
        this.playing = false;
        clearInterval(this.timeBarInterval);
        if (this.config.results.length === 0) {
            this.platform.gameover(this.playerData.score, "", JSON.stringify(this.playerData));
            return;
        }
        const result = new (0, $25326d3c4d4e80b0$export$8fdcabde73f49165)(this, this.playerData.score, this.config.results);
        this.playerData.uitslag = result.toString();
        // this.playerData.uitslag = result.config
        this.platform.gameover(this.playerData.score, result.config, JSON.stringify(this.playerData));
    }
    restart() {
        this.questionHeight = 0;
        this.cards.forEach((card)=>{
            card.destroy();
        });
        this.cards = [];
        this.playerData = new (0, $37465c1b8ae3a0af$export$129163f547cade8e)();
        this.lives = this.config.lives;
        if (this.lives) this.platform.sendLives(this.lives);
        this.timeLeft = this.config.timeLimit;
        if (this.config.shuffleCards) this.config.cards = (0, $a0f1153633232d54$export$448332262467e042)(this.config.cards);
        this.toggleVisible(this.gameScreen, true);
        for(let i = 0; i < this.config.cards.length; i++){
            if (this.config.cardLimit && i >= this.config.cardLimit) break;
            const card = this.config.cards[i];
            if (i < 2) this.cards.push(new (0, $0ccbd4977765986b$export$60332b2344f7fe41)(this, card, ()=>this.onSwipe(), i));
            if (this.config.showQuestion) this.questionHeight = Math.max(this.questionHeight, this.setQuestionElement(card));
        }
        this.questionElement.style.height = `${this.questionHeight}px`;
        this.currentCard = 0;
        this.setProgressBarWidth();
        this.nextQuestion();
        this.platform.ready();
    }
    setQuestionElement(card) {
        const question = this.config.question;
        const cardQuestionStyle = `color: ${this.config.cardQuestionColor}; font-family: ${this.config.cardQuestionFont || "inherit"}; font-size: ${this.config.cardQuestionSize}px; margin-top: ${this.config.cardQuestionSize}px;`;
        let cardQuestion = "";
        if (this.config.showCardQuestion && card.question) cardQuestion = card.question;
        this.questionElement.innerHTML = `<span>${question.trim()}</span>${cardQuestion && cardQuestion.length > 0 ? `<span style="${cardQuestionStyle}">${cardQuestion.trim()}` : ""} </span>`;
        return this.questionElement.clientHeight;
    }
    setProgressBarWidth() {
        const width = Math.round((this.currentCard + 1) / ((this.config.cardLimit && this.config.cardLimit !== 0 ? Math.min(this.config.cardLimit, this.config.cards.length) : this.config.cards.length) + 1) * 100);
        this.platform.sendProgress(width);
    }
    timePassed(time) {
        if (!this.timeLeft || !this.config.timeLimit) return;
        this.timeLeft = this.timeLeft - time;
        this.platform.sendTimeleft(this.timeLeft / this.config.timeLimit * 100);
        if (this.timeLeft <= 0) this.goToResult();
    // this.timeBarElement.style.width = `${
    // 	(this.timeLeft / this.config.timeLimit) * 100
    // }%`;
    }
    toggleVisible(element, visible) {
        if (!element) return;
        element.style.opacity = visible ? "100%" : "0";
        element.style.pointerEvents = visible ? "all" : "none";
    }
    addPoints(points) {
        this.platform.playSound(this.config.rightAnswerSound);
        this.playerData.score += points;
        this.platform.sendScore(this.playerData.score);
    // this.scoreElement.innerHTML = this.playerData.score
    // 	.toString()
    // 	.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
}



const $e45ba02351190ebe$export$de29564508b632b2 = {
    path: "https://mediadev.playsome.nl/games/swipegame/wietse_test/",
    randomize: "true",
    gamemode: "tinder",
    showCardTitle: "false",
    resultPath: "",
    revealResultText: "Tik hier!!!",
    question: "",
    cardBorderColor: "white",
    cardBorderWidth: 0,
    cardBorderRadius: 0,
    cardColor: "white",
    indicatorWidth: 75,
    indicatorPadding: 10,
    showQuestion: "true",
    results: "",
    cards: "",
    font: "Arial",
    showCardQuestion: "true"
};
class $e45ba02351190ebe$export$f807d9a22ff8372d {
    async init(settings, cardsParsed) {
        let cards;
        let results;
        if (cardsParsed) {
            cards = settings.cards.map((c)=>{
                c.image = settings.path + "/" + c.image;
                return c;
            });
            // cards = cards.reverse();
            results = settings.results.map((r)=>{
                r.image = settings.path + "/" + (settings.resultPath || "") + "/" + r.image;
                return r;
            });
        } else cards = this.getCardsFromString(settings.cards, settings.path);
        const resultPath = settings.resultPath;
        const config = {
            path: settings.path,
            cards: cards,
            question: settings.question,
            showQuestion: cardsParsed ? settings.showQuestion : settings.showQuestion === "true",
            results: cardsParsed ? settings.results : this.getResults(settings.results, settings.path + "/" + resultPath),
            shuffleCards: cardsParsed ? settings.shuffleCards : settings.shuffleCards === "true",
            showCardTitle: cardsParsed ? settings.showCardTitle : settings.showCardTitle === "true",
            lives: settings.lives ? +settings.lives : undefined,
            timeLimit: settings.timeLimit ? +settings.timeLimit : undefined,
            cardLimit: +settings.cardLimit || undefined,
            randomResult: cardsParsed ? settings.randomResult : settings.randomResult === "true",
            resultPath: resultPath,
            font: settings.font,
            rightAnswerSound: settings.rightAnswerSound,
            wrongAnswerSound: settings.wrongAnswerSound,
            swipeSound: settings.swipeSound,
            fontColor: settings.fontColor,
            fontSize: settings.fontSize,
            cardContainerColor: settings.cardContainerColor,
            cardBorderColor: settings.cardBorderColor,
            cardBorderWidth: settings.cardBorderWidth,
            cardBorderRadius: settings.cardBorderRadius,
            cardColor: settings.cardColor,
            swipeLeftIndicatorImage: settings.swipeLeftIndicatorImage,
            swipeRightIndicatorImage: settings.swipeRightIndicatorImage,
            indicatorPadding: settings.indicatorPadding,
            indicatorWidth: settings.indicatorWidth,
            showCardQuestion: cardsParsed ? settings.showCardQuestion : settings.showCardQuestion === "true",
            cardQuestionColor: settings.cardQuestionColor,
            cardQuestionFont: settings.cardQuestionFont,
            cardQuestionSize: settings.cardQuestionSize,
            cardTitleColor: settings.cardTitleColor,
            cardTitleFont: settings.cardTitleFont,
            cardTitleSize: settings.cardTitleSize,
            questionColor: settings.questionColor,
            questionFont: settings.questionFont,
            questionSize: settings.questionSize
        };
        const cardSrcs = config.cards.map((c)=>c.image);
        const resultSrcs = config.results.map((r)=>r.image);
        let imgs = [
            ...cardSrcs
        ];
        if (resultSrcs.length > 0) imgs = imgs.concat(resultSrcs);
        if (config.swipeLeftIndicatorImage && config.swipeLeftIndicatorImage !== "false" && config.swipeLeftIndicatorImage !== false) {
            config.swipeLeftIndicatorImage = config.path + "/" + config.swipeLeftIndicatorImage;
            imgs.push(config.swipeLeftIndicatorImage);
        }
        if (config.swipeRightIndicatorImage && config.swipeRightIndicatorImage !== "false" && config.swipeRightIndicatorImage !== false) {
            config.swipeRightIndicatorImage = config.path + "/" + config.swipeRightIndicatorImage;
            imgs.push(config.swipeRightIndicatorImage);
        }
        this.preloadImages(imgs).then(()=>{
            new (0, $7b066675d1aa79fa$export$38561bd03c7f0220)(config);
        });
    }
    async preloadImages(sources) {
        return new Promise((resolve)=>{
            let loadedCounter = 0;
            sources.forEach((src)=>{
                const image = new Image();
                image.onload = ()=>{
                    loadedCounter += 1;
                    if (loadedCounter === sources.length) resolve();
                };
                image.onerror = ()=>{
                    console.error(src + " was not found");
                    loadedCounter += 1;
                    if (loadedCounter === sources.length) resolve();
                };
                image.src = src;
            });
        });
    }
    getResults(resultsString, path) {
        let resultConfigs = [];
        if (resultsString.length === 0) return [];
        let splitBy = ",";
        if (resultsString.includes("|")) splitBy = "|";
        const results = resultsString.split(";").filter((s)=>s.trim().length > 0);
        results.forEach((u, i)=>{
            let min;
            let max;
            let img;
            let title;
            let text;
            const split = u.split(splitBy);
            if (!(0, $a0f1153633232d54$export$ab82360ed81b09b9)(u)) {
                min = 0;
                max = 0;
                img = split[0];
                title = split[1];
                if (split.length > 2) text = split[2];
            } else {
                if (i === 0) {
                    min = -99999;
                    max = split[0];
                    img = split[1];
                    title = split[2];
                } else if (i + 1 === results.length) {
                    max = 99999;
                    min = split[0];
                    img = split[1];
                    title = split[2];
                } else {
                    const splitMinMax = split[0].split("-");
                    min = splitMinMax[0];
                    max = splitMinMax[1];
                    img = split[1];
                    title = split[2];
                }
            }
            // if (title.trim() === "") title = undefined;
            if (split.length > 3) text = split[3];
            resultConfigs.push({
                min: +min,
                max: +max,
                image: path + "/" + img,
                title: title,
                text: text
            });
        });
        return resultConfigs;
    }
    async getCardsFromApi(rootPath, subPaths) {
        const apiUrl = undefined;
        if (!apiUrl) return [];
        const split = rootPath.split("/games/");
        const root = split[0];
        const folder = split[1];
        let call = "";
        if (subPaths) call = `?root=${this.slashToPlus(folder)}&goed=${this.slashToPlus(subPaths[0])}&fout=${this.slashToPlus(subPaths[1])}`;
        else call = `?path=${this.slashToPlus(folder)}`;
        let cardsJson = await (await fetch(apiUrl + call, {
            mode: "cors"
        })).json();
        let cards = cardsJson.map((card)=>{
            return {
                image: card.image.replace("/media", root),
                title: card.title,
                answer: card.answer
            };
        });
        return cards;
    }
    slashToPlus(s) {
        return s.replaceAll("/", "+");
    }
    getCardsFromString(cardsString, path) {
        const cards = cardsString.split(";");
        const cardConfigs = [];
        let splitBy = ",";
        if (cardsString.includes("|")) splitBy = "|";
        cards.forEach((cardString)=>{
            const split = cardString.split(splitBy);
            let cardConfig = {
                image: "",
                title: ""
            };
            if (split.length >= 3) {
                const name = split[0].trim();
                const likePoints = +split[1].trim();
                const dislikePoints = +split[2].trim();
                if (isNaN(likePoints) || isNaN(dislikePoints)) {
                    console.error(cardString + " contains a number that is NaN");
                    cardConfig = {
                        image: path + name,
                        title: name.split(".")[0].replaceAll("_", " ")
                    };
                } else cardConfig = {
                    image: path + name,
                    title: name.split(".")[0].replaceAll("_", " "),
                    points: {
                        like: +likePoints,
                        dislike: +dislikePoints
                    }
                };
            }
            if (split.length >= 4) cardConfig.question = split[3].trim();
            cardConfigs.push(cardConfig);
        });
        return cardConfigs;
    }
    constructor(){
        this.cards = [];
    }
}


let $ad2bcec7a0192558$var$config2used = false;
const $ad2bcec7a0192558$var$customConfig = $ad2bcec7a0192558$var$getSettingsFromURI(location.search);
let $ad2bcec7a0192558$var$config = (0, $e45ba02351190ebe$export$de29564508b632b2);
if ($ad2bcec7a0192558$var$customConfig) for (const [key, value] of Object.entries($ad2bcec7a0192558$var$customConfig))$ad2bcec7a0192558$var$config[key] = value;
const $ad2bcec7a0192558$var$configurator = new (0, $e45ba02351190ebe$export$f807d9a22ff8372d)();
$ad2bcec7a0192558$var$configurator.init($ad2bcec7a0192558$var$config, $ad2bcec7a0192558$var$config2used);
function $ad2bcec7a0192558$var$getSettingsFromURI(uri) {
    let settingString;
    const split = uri.split("&");
    for (let s of split){
        if (s[0] === "s" || s.includes("s2=")) try {
            settingString = decodeURIComponent(escape(atob(s.split("=")[1])));
        } catch (e) {
            settingString = atob(s.split("=")[1]);
        }
    }
    if (settingString === undefined) return null;
    let jsonString = "{";
    let settings = settingString.split("\n");
    let config2;
    settings.forEach((s)=>{
        const keyAndValue = s.split("=");
        if (keyAndValue.length === 1) return;
        const key = keyAndValue[0].trim();
        const value = keyAndValue[1].trim();
        if (key === "config") {
            $ad2bcec7a0192558$var$config2used = true;
            config2 = JSON.parse(value);
            return JSON.parse(value);
        }
        if (value === "default") return;
        let line = '"' + key.toString() + '": ';
        if (value.includes("[") && value.includes("]")) line += value.toString();
        else line += '"' + value.toString() + '"';
        if (settings.indexOf(s) < settings.length - 1) line += ",";
        jsonString += line;
    });
    if (config2) return config2;
    jsonString += "}";
    return JSON.parse(jsonString);
}


//# sourceMappingURL=index.c33d5f49.js.map
